class ComponentTrials extends Theme.Component {
  connectedCallback() {
    this.events();
    this.activateFromStorage();
  }

  activateFromStorage() {
    const product = sessionStorage.getItem('selectedProduct');
    const trial = sessionStorage.getItem('selectedTrial');
    if (!product || !trial) return;

    const targetProductTab = this.querySelector(`.trial-tab[data-product="${product}"]`);
    if (targetProductTab) targetProductTab.click();

    requestAnimationFrame(() => {
      const targetTrialButton = this.querySelector(
        `.trials[data-product="${product}"] .trial-button[data-tab="${trial}"]`
      );
      if (targetTrialButton) targetTrialButton.click();
      const top = this.getBoundingClientRect().top + window.scrollY - 200;
      window.scrollTo({ top, behavior: 'smooth' });
      sessionStorage.removeItem('selectedProduct');
      sessionStorage.removeItem('selectedTrial');
    });
  }

  onProductTabClick(_, element) {
    const clickedTab = element;
    const handle = (clickedTab.dataset.product || '').trim();
    const productTabs = this.querySelectorAll('.trial-tab[data-product]');
    productTabs.forEach(tab => tab.classList.remove('is-active'));
    clickedTab.classList.add('is-active');
    const groups = this.querySelectorAll('.trials[data-product]');
    groups.forEach(group => {
      const groupHandle = (group.dataset.product || '').trim();
      const match = groupHandle === handle;
      group.classList.toggle('is-active', match);
      if (match) {
        const firstButton = group.querySelector('.trial-button[data-tab]');
        if (firstButton) {
          const firstTab = firstButton.dataset.tab;
          group.querySelectorAll('.trial-button[data-tab]').forEach(btn => btn.classList.toggle('is-active', btn === firstButton));
          group.querySelectorAll('.trial-slide[data-tab]').forEach(slide => slide.classList.toggle('is-active', slide.dataset.tab === firstTab));
        }
      }
    });
  }

  onTrialButtonClick(_, element) {
    const button = element;
    const tab = button.dataset.tab;
    const group = button.closest('.trials[data-product]');
    if (!group) return;
    group.querySelectorAll('.trial-button[data-tab]').forEach(btn => btn.classList.remove('is-active'));
    button.classList.add('is-active');
    const slides = group.querySelectorAll('.trial-slide[data-tab]');
    slides.forEach(slide => {
      const active = slide.dataset.tab === tab;
      slide.classList.toggle('is-active', active);
    });
  }
}

customElements.define('component-trials', ComponentTrials);



class ComponentProductTrials extends Theme.Component {
  connectedCallback() {
    this.events();
    this.setupLearnMoreLinks();
  }

  setupLearnMoreLinks() {
    this.querySelectorAll('[data-trial-link]').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        const product = link.dataset.product;
        const trial = link.dataset.trialLink;
        sessionStorage.setItem('selectedProduct', product);
        sessionStorage.setItem('selectedTrial', trial);
        window.location.href = `${window.Shopify.routes.root}pages/about`;
      });
    });
  }

  onTrialButtonClick(_, element) {
    const targetTrial = element.dataset.trialBtn;
    const currentActive = this.querySelector('.trial.is-active');
    const newActive = this.querySelector(`.trial[data-trial="${targetTrial}"]`);

    if (currentActive && newActive && currentActive !== newActive) {
      currentActive.classList.remove('is-active');
      newActive.classList.add('is-active');
    }
  }
}

customElements.define('component-product-trials', ComponentProductTrials);